import { useMsal } from "@azure/msal-react";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Space, Switch } from "antd";
import axios from "axios";
import { Buffer } from "buffer";
import { useContext, useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { NavLink, Redirect, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  ABOUT,
  BI_PRODUCT_FLAG,
  DATABOOK_IMG,
  ERRORS,
  GOVERN_ITEMS,
  SUPPORT_IMG,
  DATA_CATALOGUE_IMG,
  DATA_ASSISTANT_IMG,
  OBSERVABILITY_USERS,
} from "../constants/Constant";
import LANDINGSECTION from "../constants/LandingConstant";
import { GRAPHME_URI, YAMMER_URL } from "../constants/serverConfig";
import { protectedResources } from "../msalConfig";
import { NavBarAndLandingPageContext } from "../NavBarContextAndLandingPageContext";
import DropdownContent from "../utils/ReUsableComponents/DropdownContent";
import GovernDropdownContent from "../utils/ReUsableComponents/GovernDropdownContent";
import AutocompleteDatasetsWrapper from "./AutocompleteDatasetsWrapper";

const NavBar = () => {
  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const [colorChange, setColorchange] = useState(false);
  const [isShownNav, setIsShowNav] = useState(false);
  const [activeNavLink, setActiveNavLink] = useState("dataAssets");
  const [searchButtonCounter, setSearchButtonCounter] = useState(0);
  const { setRoleToggle, roletoggle, setSearchKeyword, searchKeyword, tabcriteria } =
    useContext(NavBarAndLandingPageContext);


  let username = account.username;
  let obsUsers = OBSERVABILITY_USERS.filter((item) => item.toLowerCase());

  const metricKeys = [
    "metric-name",
    "metric-desc",
    "metric-tag",
    "metric-classification",
    "metric-sensitivity",
    "metric-col-name",
    "metric-col-desc",
    "metric-col-tag",
    "metric-col-classification",
    "metric-col-sensitivity",
  ];


  const handleNavLinkClick = (navLinkId) => {
    setActiveNavLink(navLinkId);
  };

  const handleNav = (event) => {
    setIsShowNav((current) => !current);
  };

  const changeNavbarColor = () => {
    if (window.scrollY >= 80) {
      setColorchange(false);
    } else {
      setColorchange(false);
    }
  };
  window.addEventListener("scroll", changeNavbarColor);

  const [avatar, setAvatar] = useState();
  const [textAvatar, setTextAvatar] = useState();
  const request = {
    scopes: protectedResources.graphMe.scopes,
    account: account,
  };

  const getProfile = (token) => {
    axios({
      method: "get",
      url: GRAPHME_URI,
      headers: {
        Authorization: `bearer ${token}`,
      },
      responseType: "arraybuffer",
    })
      .then((res) => {
        const avatar = Buffer.from(res.data).toString("base64");
        setAvatar(avatar);
      })
      .catch((error) => {
        if (
          error.response &&
          // error.response.statusText === ERRORS.MSG.NOTFOUND
          error.response.status === 404
        ) {
          const myNameArray = account.name.split(" ");
          const myProfile = myNameArray[0].charAt(0) + myNameArray[1].charAt(0);
          setTextAvatar(myProfile);
        }
      });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = (await instance.acquireTokenSilent(request)).accessToken;
        getProfile(token);
      } catch (error) {
        if (error) {
          try {
            const token = (await instance.acquireTokenRedirect(request))
              .accessToken;
            getProfile(token);
          } catch (error) {
            console.log("failed to generate acquire token redirect", error);
            toast.error("failed to generate acquire token redirect" + error, {
              position: "top-right",
              autoClose: 6000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        }
      }
    };
    fetchData();
  }, [instance]);

  let navigate = useNavigate();
  const navigateToDetailsPage = (item, assetType) => {
    if (assetType === BI_PRODUCT_FLAG) {
      navigate("/databook/bicatalog/dashboard/" + item);
    } else {
      navigate("/databook/datasets/alldatasets/" + item);
    }
  };

  const navigateToViewAllPage = (term, criteria) => {
    if (metricKeys.includes(criteria)) {
      console.log(term, "term");
      navigate("/databook/metric-catalog/", {
        state: { searchterm: term },
      });
      return;
    }
    if (searchKeyword.term?.length < 3) {
      toast.warn(
        "Searched keyword can't be blank and should be more then 3 characters.",
        {
          position: "top-right",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      return false;
    }

    setSearchButtonCounter(searchButtonCounter + 1);
    let GLOBAL_SEARCH_ACT = "SEARCH_TRIGGER_" + searchButtonCounter + 1;
    // navigate("/databook/viewalldatasets/" + term, {
    navigate("/databook/viewalldatasets", {
      state: { actionType: GLOBAL_SEARCH_ACT, searchterm: term },
    });
  };

  const userSwitch = (flag) => {
    setRoleToggle(!roletoggle);
  };
  const backToLandingPage = () => {
    setSearchKeyword({
      criteria: "dataset-name",
      term: "",
    });
    navigate(LANDINGSECTION.DATABOOK_LANDING_URL);
  };

  return (
    <nav
      role="navigation"
      className={colorChange ? "navbar colorChange" : "navbar"}
    >
      <Container className="header__width main-nav p-1">
        <div>
          <div className="dataset-likes" onClick={backToLandingPage}>
            <img
              src={DATABOOK_IMG}
              className="databk__img"
              alt="Data Book Logo"
            />
          </div>
          {/* <div onClick={() => window.open(YAMMER_URL, "_blank")} className="ps-4 yammer-link"> Databook Community</div> */}
        </div>

        <div className="autocomplete-dataset-search w-40  search-widh-adjust">
          <AutocompleteDatasetsWrapper
            navigateToDetailsPage={navigateToDetailsPage}
            navigateToViewAllPage={navigateToViewAllPage}
            setSearchKeyword={setSearchKeyword}
            searchKeyword={searchKeyword}
            tabcriteria={tabcriteria}
          />
        </div>

        <div
          id="mainnav"
          className={isShownNav ? "#mainnav active" : "#mainnav"}
        >
          {/* commented for now, will be used in future */}

          {/* <div className="persona-toggle px-3">
            <span>

              <Space direction="vertical">
                <Switch
                  style={{ backgroundColor: '#777777', }}
                  checkedChildren="Business"
                  unCheckedChildren="Technical"
                  checked={roletoggle}
                  onClick={userSwitch}
                />
              </Space>

            </span>
          </div> */}
          {/* <div className="supportrelease-section">
            <NavLink to={{ YAMMER_URL }} target="_blank">
              <span>Community</span>
            </NavLink>
          </div> */}
          <div
            className={
              activeNavLink === "dataAssets"
                ? "activeUnderline supportrelease-section"
                : "supportrelease-section"
            }
            onClick={() => handleNavLinkClick("dataAssets")}
          >
            <NavLink to="/databook/datasets">
              <img
                src={DATA_CATALOGUE_IMG}
                className="supprot-service-img"
                alt="support&service"
              />
              <span>Data Assets</span>
            </NavLink>
          </div>
          {obsUsers?.indexOf(username?.toLowerCase()) > -1 ?
            (
              <div
                className={
                  activeNavLink === "dataAssets"
                    ? "supportrelease-section"
                    : "supportrelease-section"
                }
                onClick={() => handleNavLinkClick("dataAssets")}
              >
                <NavLink to="/databook/observability/info">

                  <span>Observability</span>
                </NavLink>
              </div>
            ) :
            ""}

          {/* <div
            // className="supportrelease-section"
            className={
              activeNavLink === "dataAssistant"
                ? "activeUnderline supportrelease-section"
                : "supportrelease-section marginRight"
            }
            onClick={() => handleNavLinkClick("dataAssistant")}
          >
            <NavLink to="/databook/dataassistant">
              <img
                src={DATA_ASSISTANT_IMG}
                className="supprot-service-img"
                alt="support&service"
              />
              <span>Data Assistant</span>
            </NavLink>
          </div> */}
          {/* <div className="dropdown__section">
            <GovernDropdownContent dropdownData={ABOUT} />
          </div> */}

          <DropdownContent dropdownData={GOVERN_ITEMS} />
          <span className="user">
            {avatar ? (
              <img
                className="user"
                src={"data:image/jpeg;base64, " + avatar}
                alt="profile pic"
              />
            ) : (
              <div className="profiletext">
                {/* <div className="profiletext text-dark"> */}
                <span>{textAvatar}</span>
              </div>
            )}
          </span>
        </div>
        <div id="mobile" onClick={handleNav}>
          {isShownNav ? (
            <FontAwesomeIcon icon={faTimes} />
          ) : (
            <FontAwesomeIcon icon={faBars} />
          )}
        </div>
      </Container>
    </nav>
  );
};

export default NavBar;
